import { Gift } from "lucide-react";
import { toast } from "sonner";
import { useGoFundMe } from "@/hooks/useGoFundMe";
import { cn } from "@/lib/utils";

export default function DonateButton({ className, children, testid = "donate-button", variant = "solid", size = "md" }) {
  const url = useGoFundMe();

  const handleClick = (e) => {
    e.preventDefault();
    if (!url) {
      toast.info("The GoFundMe link is coming soon — thank you for your kindness 💛");
      return;
    }
    const win = window.open(url, "_blank", "noopener,noreferrer");
    if (!win || win.closed || typeof win.closed === "undefined") {
      try {
        window.top.location.href = url;
      } catch {
        window.location.href = url;
      }
    }
  };

  const base =
    "group inline-flex items-center justify-center gap-2 rounded-full font-medium transition-all duration-300 active:scale-[0.97]";
  const sizes = { md: "h-12 px-7 text-sm", lg: "h-14 px-9 text-base" };
  const variants = {
    solid:
      "bg-terracotta text-cream shadow-[0_14px_30px_-12px_rgba(200,106,76,0.7)] hover:bg-terracotta-dark hover:shadow-[0_18px_40px_-12px_rgba(200,106,76,0.8)]",
    outline:
      "border border-cream/70 text-cream backdrop-blur-sm hover:bg-cream hover:text-forest",
    ghostGold:
      "border border-gold/50 text-forest hover:bg-gold/10",
  };

  return (
    <a
      href={url || "#"}
      onClick={handleClick}
      target={url ? "_blank" : undefined}
      rel="noreferrer"
      data-testid={testid}
      className={cn(base, sizes[size], variants[variant], className)}
    >
      <Gift className="h-4 w-4 transition-transform group-hover:scale-125" />
      {children || "Give a Birthday Gift"}
    </a>
  );
}
